"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.METADATA_SERVICE_KEYS = exports.SITE_FILTER_METADATA_KEY = void 0;
exports.SITE_FILTER_METADATA_KEY = 'sitefilter';
exports.METADATA_SERVICE_KEYS = [exports.SITE_FILTER_METADATA_KEY];
